export default __webpack_public_path__ + "static/media/1931.82f272c2.png";